import {Color, ShaderMaterial, Vector2} from "three";

import markerVertex from "features/apartmentViewer/ApartmentViewer/shaders/markerMaterial/markerVertex.glsl";
import markerFragment from 'features/apartmentViewer/ApartmentViewer/shaders/markerMaterial/markerFragment.glsl';

export class MarkerMaterialFactory {
    public static createMaterial(color: Color = new Color(1, 1, 1), depthOffset: number = 0) : ShaderMaterial {
        return new ShaderMaterial({
            uniforms: {
                map: {
                    value: null // Texture map
                },
                color: {
                    value: color // Material color
                },
                repeat: {
                    value: new Vector2(1, 1) // UV repeat for textures
                },
                depthOffset: {
                    value: depthOffset // Depth offset for rendering
                },
                alpha: {
                    value: 1.0 // Alpha value for transparency
                },
                isHovered: {
                    value: false // Hover state
                }
            },
            depthWrite: false, // Prevents depth conflicts
            transparent: true,
            // Vertex Shader: passing texture coordinates and calculating position
            vertexShader: markerVertex,

            // Fragment Shader: Handles the exposure, tonemapping, and LUT application
            fragmentShader: markerFragment,
            polygonOffset: true,
            polygonOffsetFactor: -1, // Pushes the geometry slightly
            polygonOffsetUnits: -1,

        })
    }
}
